import React from 'react';
import { useQuery } from 'react-query';
import { api } from "../../../api";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { extractCenterId } from "../../../utils/center";
import DeliverooOrdersTable from './DeliverooOrdersTable';
import DeliverooSiteStatusIndicator from './DeliverooSiteStatusIndicator';

import '../../uber-eats/css/UberEatsOrders.css';

const DeliverooOrders = ({ centerId }) => {
  const { isLoading, isError, data, error } = useQuery(
    ['deliverooOrders', centerId],
    (_key, id) => api.listAllDeliverooOrders(id),
    {
      enabled: !!centerId,
      refetchInterval: 10000, // 10secs
    });

  return (
    <>
      <DeliverooSiteStatusIndicator />
      <div className="uber-section-header">
        <h4>Commandes Deliveroo ({data && data.current_orders && data.current_orders.length || 0})</h4>
      </div>
      <div style={{ margin: '0 0 10px' }}>
        Appeler un rider supplémentaire (appeler ce numéro{' '}
        <a href="tel:+33977550331">09 77 55 03 31</a>)
      </div>
      {isLoading && <div>Loading...</div>}
      {isError && <div>{error.message}</div>}
      {data &&
        <DeliverooOrdersTable
          orders={data.current_orders || []}
          centerId={centerId}
        />
      }
    </>
  );
};

DeliverooOrders.propTypes = {
  centerId: PropTypes.number,
  centers: PropTypes.array,
};

export const ConnectedDeliverooOrders = connect(
  (state) => {
    return {
      centers: (
        state.m.metas.centers
        || state.dispatch.metas.centers
        || []
      ),
      centerId: extractCenterId(state.user),
    };
  }
)(DeliverooOrders);

export default ConnectedDeliverooOrders;
